// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoBackground_container__BJdSR"};